<script setup lang="ts">
// `defineAsyncComponent` keeps the dev-console implementation out of the
// production bundle: `isDevBuild` is a build-time literal (false in prod),
// so the import factories below tree-shake to nothing.
import { defineAsyncComponent, onMounted, onUnmounted } from 'vue'
import { useReviewDraftsStore } from '@/stores/reviewDrafts'
import { isDevBuild } from '@/utils/isDev'

const reviewDrafts = useReviewDraftsStore()

function warnBeforeDraftUnload(event: Event): void {
  if (!reviewDrafts.hasUnsavedWork()) return
  event.preventDefault()
  ;(event as unknown as { returnValue: string }).returnValue = ''
}

onMounted(() => window.addEventListener('beforeunload', warnBeforeDraftUnload))
onUnmounted(() => window.removeEventListener('beforeunload', warnBeforeDraftUnload))

const BackendBanner = isDevBuild
  ? defineAsyncComponent(
      // fallow-ignore-next-line unresolved-import -- dev-server-only URL
      () => import(/* @vite-ignore */ '/src/devtools/BackendBanner.vue'),
    )
  : null
const BackendConsole = isDevBuild
  ? defineAsyncComponent(
      // fallow-ignore-next-line unresolved-import -- dev-server-only URL
      () => import(/* @vite-ignore */ '/src/devtools/BackendConsole.vue'),
    )
  : null
</script>

<template>
  <component :is="BackendBanner" v-if="isDevBuild" />
  <router-view />
  <component :is="BackendConsole" v-if="isDevBuild" />
</template>
